/**
 * "Let's Talk" — Fast staggered character reveal
 * Characters fly in from below with a quick cascade when section enters viewport.
 */

document.addEventListener('DOMContentLoaded', () => {
    const wrapper = document.querySelector('.Horizontal');
    const text = document.querySelector('.Horizontal__text');

    if (!wrapper || !text) return;

    // Preserve link but split characters inside
    const link = text.querySelector('a');
    const target = link || text;
    const originalText = target.innerText.trim();
    target.innerHTML = '';

    [...originalText].forEach((char) => {
        const span = document.createElement('span');
        span.style.display = 'inline-block';
        span.style.whiteSpace = 'pre';
        span.textContent = char;
        target.appendChild(span);
    });

    const chars = target.querySelectorAll('span');

    // Set initial state — all characters hidden
    gsap.set(chars, {
        yPercent: 120,
        opacity: 0,
        rotation: () => gsap.utils.random(-6, 6),
    });

    // Animate all characters in with a fast stagger when section scrolls into view
    gsap.to(chars, {
        yPercent: 0,
        opacity: 1,
        rotation: 0,
        duration: 0.6,
        ease: 'power3.out',
        stagger: 0.03,
        scrollTrigger: {
            trigger: wrapper,
            start: 'top 80%',
            toggleActions: 'play none none none',
        },
    });
});
